import React from 'react';

export default function Clock(props) {
    return (
        <svg
            width="22px"
            height="22px"
            viewBox="0 0 22 22"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            {...props}
        >
            {/* Generator: Sketch 48.2 (47327) - http://www.bohemiancoding.com/sketch */}
            <title>Group</title>
            <desc>Created with Sketch.</desc>
            <defs />
            <g
                id="Page-1"
                stroke="none"
                strokeWidth={1}
                fill="none"
                fillRule="evenodd"
            >
                <g id="Group" fill="#000000" fillRule="nonzero">
                    <path
                        className={props.className}
                        // eslint-disable-next-line
                        d="M11,0 C4.93424525,0 0,4.93424525 0,11 C0,17.0657557 4.93424525,22 11,22 C17.0657557,22 22,17.0657557 22,11 C22,4.93424525 17.0657557,0 11,0 Z M11,1.83333333 C16.073893,1.83333333 20.1666667,5.926107 20.1666667,11 C20.1666667,16.073893 16.073893,20.1666667 11,20.1666667 C5.926107,20.1666667 1.83333333,16.073893 1.83333333,11 C1.83333333,5.926107 5.926107,1.83333333 11,1.83333333 Z M10.0833333,3.66666667 L10.0833333,11.9166667 L16.5,11.9166667 L16.5,10.0833333 L11.9166667,10.0833333 L11.9166667,3.66666667 L10.0833333,3.66666667 Z"
                        id="Shape"
                    />
                </g>
            </g>
        </svg>
    );
}



// WEBPACK FOOTER //
// ./src/lib/icons/Clock.jsx